import Vuex from 'vuex';

import modules from './modules';

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules,
    strict: debug,
});
